import { Decoration_Type } from './../../ricos-schema/legacy/wix/rich_content/v1';
import type { EditorPlugin } from './../../ricos-types';
import { createShortcut } from './../../ricos-types';
import { RESOLVERS_IDS } from './../../toolbars-v3/lib/resolvers-ids';

import { boldConverter } from './bold-converter';
import BoldIcon from './BoldIcon';
import { TEXT_BUTTON_BOLD } from './data-hooks';
import { bold } from './extension';

export const pluginBold: EditorPlugin = {
  type: Decoration_Type.BOLD,
  config: {},
  pmNodeConverters: [],
  pmMarkConverters: [boldConverter],
  tiptapExtensions: [bold],
  shortcuts: [
    createShortcut({
      name: Decoration_Type.BOLD,
      description: 'ShortcutsSheet_Formatting_Bold',
      keys: { macOs: 'Meta+B', windows: 'Ctrl+B' },
      command({ publicCommands }) {
        publicCommands.toggleInlineStyle('bold');
      },
      group: 'ShortcutsSheet_Section_Formatting',
      enabled: true,
    }),
  ],

  textButtons: [
    {
      id: Decoration_Type.BOLD,
      type: 'toggle',
      presentation: {
        dataHook: TEXT_BUTTON_BOLD,
        tooltip: 'BoldButton_Tooltip',
        icon: BoldIcon,
      },
      attributes: {
        visible: RESOLVERS_IDS.ALWAYS_VISIBLE,
        active: RESOLVERS_IDS.IS_TEXT_CONTAINS_BOLD,
        disabled: RESOLVERS_IDS.IS_NODE_SELECTED,
      },
      command:
        ({ publicCommands }) =>
        () => {
          publicCommands.toggleInlineStyle('bold');
          return true;
        },
    },
  ],
};
